import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function GTMScript() {
  const [gtmId, setGtmId] = useState<string | null>(null);

  useEffect(() => {
    const fetchGTMSettings = async () => {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('gtm_id, gtm_enabled')
          .single();

        if (error) {
          console.error('Erro ao buscar configurações GTM:', error);
          return;
        }

        if (data?.gtm_enabled && data?.gtm_id) {
          setGtmId(data.gtm_id);
        }
      } catch (error) {
        console.error('Erro ao buscar GTM:', error);
      }
    };

    fetchGTMSettings();
  }, []);

  useEffect(() => {
    if (!gtmId) return;

    // Verificar se já existe para evitar duplicação
    if (document.getElementById('gtm-script')) return;

    // Inserir GTM no <head>
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(script);

    // Inserir noscript no <body>
    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);

    console.log('GTM carregado:', gtmId);

    // Cleanup
    return () => {
      const existingScript = document.getElementById('gtm-script');
      const existingNoscript = document.getElementById('gtm-noscript');
      if (existingScript) existingScript.remove();
      if (existingNoscript) existingNoscript.remove();
    };
  }, [gtmId]);

  return null;
}
